import { Component, OnInit } from '@angular/core';

import { Controllers } from '@shared/core/controllers';

import { Observable } from 'rxjs';

@Component({
    selector: 'shared-order-confirmation-hero-header',
    templateUrl: './order-confirmation-hero-header.shared.component.html',
    styleUrls: ['./order-confirmation-hero-header.shared.component.scss']
})
export class OrderConfirmationHeroHeaderComponent implements OnInit {
    public isLoading$: Observable<boolean>;
    public orderId$: Observable<number>;
    public locationNo$: Observable<number>;

    constructor(
        public controllers: Controllers,
    ) { }

    ngOnInit(): void {
        this.isLoading$ = this.controllers.routes.extractOrderWithLocationLoadingFromQueryParams$();
        this.orderId$ = this.controllers.routes.extractOrderIdFromQueryParams$();
        this.locationNo$ = this.controllers.routes.extractLocationNoFromQueryParams$();
    }
}
